export const API_URL = 'https://api.cockfight.shop';
// export const API_URL = "http://localhost:3001";
// export const CHAIN = "FHENIX";
export const CHAIN = 'CELO';
// chain list
// "CELO"
// "KLAYTN"
// "NEON"
// "FHENIX"
